import React from 'react';

const ReferFarmerIcon = ({ ...props }) => (
  <svg
    {...props}
    id="invite_farmer_icon"
    dataname="invite farmer icon"
    xmlns="http://www.w3.org/2000/svg"
    width="55.233"
    height="63.11"
    viewBox="0 0 55.233 63.11"
  >
    <path
      id="Path_1695"
      dataname="Path 1695"
      d="M346.159,145.814a23.8,23.8,0,0,1-3.7-.657,27.512,27.512,0,0,0-4.057-.72c-.029,0-.669-.008-.929,0a31.085,31.085,0,0,0-3.923.7,23.506,23.506,0,0,1-4.015.68l0,0c-.033,0-.065,0-.1-.007,1.25,4.366,3.544,7.249,6.951,8.763h0a12.993,12.993,0,0,0,1.809.659l.057.016a10.549,10.549,0,0,0,3.31-1.889h0A15.568,15.568,0,0,0,346.159,145.814Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1696"
      dataname="Path 1696"
      d="M329.188,155.054h.017l.584-.11a4.336,4.336,0,0,0,1.012-.239h0a16.633,16.633,0,0,1-3.814-5.937l-11.078,9.312,1.2,1.022h0l1.294,1.1a7.614,7.614,0,0,1,1.4-1.726l.015-.014h0C321.333,157.113,323.326,156.151,329.188,155.054Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1697"
      dataname="Path 1697"
      d="M341.57,153.362h0l5.325-1.249h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1698"
      dataname="Path 1698"
      d="M319.815,158.465h0l16.579-3.89h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1699"
      dataname="Path 1699"
      d="M348.713,148.475a18.3,18.3,0,0,1-1.819,3.638h0a18.341,18.341,0,0,1-2,2.6,4.15,4.15,0,0,0,.94.222l.691.13a.408.408,0,0,0,.059.011c5.723,1.084,7.761,2.074,9.273,3.391a8.769,8.769,0,0,1,1.522,1.773l2.561-2.15L351.656,151h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1700"
      dataname="Path 1700"
      d="M328.843,141.3v.184h0v.447a1.587,1.587,0,0,0,.692.613,27.6,27.6,0,0,0,3.325-.606,30.57,30.57,0,0,1,4.507-.774c.3-.01,1.056,0,1.056,0a27.262,27.262,0,0,1,4.74.8,25.337,25.337,0,0,0,3.124.584c.179,0,.47-.27.679-.557v-.719a63.746,63.746,0,0,0-9.091-1.427c-1.323.1-2.64.251-3.951.447h-.005C332.213,140.546,330.517,140.876,328.843,141.3Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1701"
      dataname="Path 1701"
      d="M351.656,151l3.945-.925h0l-3.945.925Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1702"
      dataname="Path 1702"
      d="M348.636,166.817h.912l.762-.64h0l4.537-3.81a5.914,5.914,0,0,0-1.137-1.435c-.718-.625-1.745-1.294-5.075-2.085v7.723h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1703"
      dataname="Path 1703"
      d="M333.919,140.291h0l11.453-2.687h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1704"
      dataname="Path 1704"
      d="M348.636,166.57h0l-14.991,3.517h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1705"
      dataname="Path 1705"
      d="M357.366,164.522h0l-7.056,1.655h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1706"
      dataname="Path 1706"
      d="M362.258,163.374l3.263-.765h0l-3.263.765Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1707"
      dataname="Path 1707"
      d="M362.258,163.374h0v-1.579a3.891,3.891,0,0,0-.2-1.211l-4.691,3.937h0l-18.582,15.6a1.637,1.637,0,0,1-2.113-.009l-9.862-8.42h0l-13.045-11.137a3.823,3.823,0,0,0-.2,1.241v13h0v10.518a3.888,3.888,0,0,0,2.738,3.705h0a3.881,3.881,0,0,0,1.161.195h40.9a3.9,3.9,0,0,0,3.9-3.9v-7.078h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1708"
      dataname="Path 1708"
      d="M337.742,176.724l7.906-6.638h-15.68l.793.677h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1709"
      dataname="Path 1709"
      d="M330.761,170.764h0l-3.952.927h0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1710"
      dataname="Path 1710"
      d="M328.843,141.482l-3.265.766h0l3.265-.766Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1711"
      dataname="Path 1711"
      d="M327.176,166.817V158.81c-3.477.808-4.5,1.482-5.2,2.109a5.154,5.154,0,0,0-1.051,1.45l5.211,4.448Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1712"
      dataname="Path 1712"
      d="M345.358,159.336l-6.582,4.694a1.634,1.634,0,0,1-1.9,0l-6.429-4.633v7.42l14.911,0Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1713"
      dataname="Path 1713"
      d="M337.84,160.689l4.895-3.488a2.741,2.741,0,0,1-.377-.369,13.861,13.861,0,0,1-3.059,1.509,3.128,3.128,0,0,1-1.055.18,3.217,3.217,0,0,1-.939-.14,15.7,15.7,0,0,1-3.9-1.663,2.693,2.693,0,0,1-.44.459Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1714"
      dataname="Path 1714"
      d="M313.558,174.8l-3.27.767h0l3.27-.767Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1715"
      dataname="Path 1715"
      d="M341.337,132.648h-7.261c-.076,0-.153,0-.229,0a5.089,5.089,0,0,0-5,5.176v.13c2.631-.583,6.951-1.45,9.137-1.368a63.212,63.212,0,0,1,7.392,1.019h0c.532.1,1.064.209,1.593.327v-.109a5.767,5.767,0,0,0-.058-.578h0A5.424,5.424,0,0,0,341.337,132.648Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1716"
      dataname="Path 1716"
      d="M346.912,137.244l3.177-.745h0l-3.177.745Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1717"
      dataname="Path 1717"
      d="M317.1,159.1l-6.722,1.577h0l6.723-1.577Z"
      transform="translate(-310.288 -129.374)"
      fill="none"
    />
    <path
      id="Path_1718"
      dataname="Path 1718"
      d="M317.455,192.484h40.9a7.175,7.175,0,0,0,7.166-7.167v-7.843l-3.263.765v7.078a3.9,3.9,0,0,1-3.9,3.9h-40.9a3.881,3.881,0,0,1-1.161-.195l-4.24.995A7.15,7.15,0,0,0,317.455,192.484Z"
      transform="translate(-310.288 -129.374)"
      fill="#b95700"
    />
    <path
      id="Path_1719"
      dataname="Path 1719"
      d="M349.548,166.817h-.912v-.247l-14.989,3.516h12l-7.906,6.638-6.981-5.96-3.952.927,9.862,8.42a1.637,1.637,0,0,0,2.113.009l18.582-15.6-7.056,1.655Z"
      transform="translate(-310.288 -129.374)"
      fill="#eb6909"
    />
    <path
      id="Path_1720"
      dataname="Path 1720"
      d="M313.558,185.317V174.8l-3.27.768v9.75a7.137,7.137,0,0,0,1.768,4.7l4.24-.994A3.888,3.888,0,0,1,313.558,185.317Z"
      transform="translate(-310.288 -129.374)"
      fill="#eb6909"
    />
    <path
      id="Path_1721"
      dataname="Path 1721"
      d="M362.258,178.239l3.263-.766V162.609l-3.263.765Z"
      transform="translate(-310.288 -129.374)"
      fill="#eb6909"
    />
    <path
      id="Path_1722"
      dataname="Path 1722"
      d="M362.258,178.239l3.263-.766h0l-3.263.766Z"
      transform="translate(-310.288 -129.374)"
      fill="#eb6909"
    />
    <path
      id="Path_1723"
      dataname="Path 1723"
      d="M316.3,189.022l-4.24.995h0l4.24-.995Z"
      transform="translate(-310.288 -129.374)"
      fill="#eb6909"
    />
    <path
      id="Path_1724"
      dataname="Path 1724"
      d="M313.558,161.794a3.823,3.823,0,0,1,.2-1.241l13.045,11.137,3.953-.927-.793-.677h3.677l14.991-3.516v-7.723c3.33.791,4.357,1.46,5.075,2.085a5.914,5.914,0,0,1,1.137,1.435l-4.537,3.81,7.056-1.656,4.691-3.937a3.891,3.891,0,0,1,.2,1.211v1.579l3.263-.766v-.814a7.142,7.142,0,0,0-1.756-4.685l-.016-.021c-.022-.025-.043-.053-.065-.079s-.056-.049-.084-.076-.042-.05-.069-.072l-7.93-6.79-3.945.925,8.284,7.094-2.561,2.15a8.769,8.769,0,0,0-1.522-1.773c-1.512-1.317-3.55-2.307-9.273-3.391a.408.408,0,0,1-.059-.011l-.691-.13a4.15,4.15,0,0,1-.94-.222,18.341,18.341,0,0,0,2-2.6l-5.325,1.25a10.549,10.549,0,0,1-3.31,1.889l-.057-.016a12.993,12.993,0,0,1-1.809-.659l-16.579,3.889-.015.014a7.614,7.614,0,0,0-1.4,1.726l-1.294-1.1-6.722,1.577a7.022,7.022,0,0,0-.1,1.115v13.772l3.27-.767Zm19.847-5.077h0a15.7,15.7,0,0,0,3.9,1.663,3.217,3.217,0,0,0,.939.14,3.128,3.128,0,0,0,1.055-.18,13.861,13.861,0,0,0,3.059-1.509,2.741,2.741,0,0,0,.377.369l-4.895,3.488-4.874-3.512a2.693,2.693,0,0,0,.44-.459Zm-2.958,2.68,6.429,4.633a1.634,1.634,0,0,0,1.9,0l6.582-4.694v7.478l-14.911,0Zm-8.471,1.522c.7-.627,1.723-1.3,5.2-2.109v8.007h-1.04l-5.211-4.448A5.154,5.154,0,0,1,321.976,160.919Z"
      transform="translate(-310.288 -129.374)"
      fill="#5f9501"
    />
    <path
      id="Path_1725"
      dataname="Path 1725"
      d="M333.405,156.717h0Z"
      transform="translate(-310.288 -129.374)"
      fill="#5f9501"
    />
    <path
      id="Path_1726"
      dataname="Path 1726"
      d="M315.906,158.079l11.078-9.312A16.633,16.633,0,0,0,330.8,154.7h0a4.336,4.336,0,0,1-1.012.239l-.584.11h-.017c-5.862,1.1-7.855,2.059-9.373,3.411l16.577-3.889c-3.407-1.514-5.7-4.4-6.951-8.763.031,0,.063.007.1.007l0,0a23.506,23.506,0,0,0,4.015-.68,31.085,31.085,0,0,1,3.923-.7c.26-.008.9,0,.929,0a27.512,27.512,0,0,1,4.057.72,23.8,23.8,0,0,0,3.7.657,15.568,15.568,0,0,1-4.589,7.548l5.324-1.249a18.3,18.3,0,0,0,1.819-3.638L351.655,151l3.945-.926-5.869-5.026c.042-.191.092-.377.131-.573.037-.147.144-.578.18-.785.011-.073.026-.151.042-.234a6.915,6.915,0,0,0,.153-1.376V137.82a8.728,8.728,0,0,0-.149-1.322l-3.176.746a5.767,5.767,0,0,1,.058.578v.109c-.529-.118-1.061-.222-1.593-.327l-11.453,2.687c1.311-.2,2.628-.351,3.951-.447a63.746,63.746,0,0,1,9.091,1.427v.719c-.209.287-.5.557-.679.557a25.337,25.337,0,0,1-3.124-.584,27.262,27.262,0,0,0-4.74-.8s-.752-.01-1.056,0a30.57,30.57,0,0,0-4.507.774,27.6,27.6,0,0,1-3.325.606,1.587,1.587,0,0,1-.692-.613v-.447l-3.265.766v.118a10.58,10.58,0,0,0,.235,2.367l.048.248a.2.2,0,0,0,.008.04c.024.116.058.228.084.344l-13.627,11.452c-.026.022-.048.05-.073.074a.808.808,0,0,0-.081.074c-.024.028-.041.051-.063.075-.006.008-.016.016-.021.024a7.131,7.131,0,0,0-1.705,3.613l6.722-1.577Z"
      transform="translate(-310.288 -129.374)"
      fill="#79b61d"
    />
    <path
      id="Path_1727"
      dataname="Path 1727"
      d="M328.843,141.3c1.674-.422,3.37-.752,5.076-1.007l11.457-2.688a63.212,63.212,0,0,0-7.392-1.019c-2.186-.082-6.506.785-9.137,1.368v-.13a5.089,5.089,0,0,1,5-5.176c.076,0,.153,0,.229,0h7.261a5.424,5.424,0,0,1,5.574,4.6l3.177-.745a8.685,8.685,0,0,0-8.751-7.121h-7.259a8.285,8.285,0,0,0-8.5,8.069c0,.125,0,.25,0,.374v4.428l3.265-.766Z"
      transform="translate(-310.288 -129.374)"
      fill="#c8d200"
    />
  </svg>
);

export default ReferFarmerIcon;
